import {apiGlobal} from './index'
import {LOCAL_STORAGE} from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const sentencePracticeEndPoints = {
  GET_RESPONSE_BY_BOT:
    'iesv/api/v1/knowledge-notebook-sentence-practices/answers', // Lấy phản hồi của bot
  SEND_AUDIO: 'iesv/api/v1/knowledge-notebook-sentence-practices/answers', // Gửi audio phát âm của user
  GET_PRACTICE_OVERVIEW:
    'iesv/api/v1/knowledge-notebook-sentence-practices/users/practice-overviews', // Lấy danh sách các folder có câu cần ôn
  GET_SENTENCES_BY_FOLDER:
    'iesv/api/v1/knowledge-notebook-sentence-practices/users/folders', // Lấy danh sách các câu cần ôn theo folder_id
  INIT_SESSION:
    'iesv/api/v1/knowledge-notebook-sentence-practices/users/practices/sessions', // Khởi tạo 1 session ôn câu
  GET_SENTENCES_SUMMARY:
    'iesv/api/v1/knowledge-notebook-sentence-practices/users/practices', // Lấy tổng kết sau khi ôn câu xong
  INIT_SESSION_ROLE_PLAY:
    'iesv/api/v1/knowledge-notebook-sentence-practices/users/practices/role-play/sessions', //  Khởi tạo 1 session ôn câu dạng 2
  GET_ROLE_PLAY_DETAILS:
    'iesv/api/v1/knowledge-notebook-sentence-practices/users/practices', // Lấy chi tiết dạng 2
  SEND_AUDIO_ROLE_PLAY:
    'iesv/api/v1/knowledge-notebook-sentence-practices/role-play-answers', // Gửi audio phát âm của user ở dạng 2
}

const sentencePracticeRequest = {
  sendAudio: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${sentencePracticeEndPoints.SEND_AUDIO}?session-id=${params.sessionId}`,
        params.formData,
        {},
        true,
      )
    }
  },
  sendAudioRolePlay: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${sentencePracticeEndPoints.SEND_AUDIO_ROLE_PLAY}?practice-history-id=${params.practiceHistoryId}&user-answer-bucket-id=${params.userAnswerBucketId}`,
        params.formData,
        {},
        true,
      )
    }
  },
  getOverview: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        sentencePracticeEndPoints.GET_PRACTICE_OVERVIEW,
        {},
      )
    }
  },
  getSentences: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${sentencePracticeEndPoints.GET_SENTENCES_BY_FOLDER}/${params.folderId}/practice-sentences`,
        {},
      )
    }
  },
  initSession: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${sentencePracticeEndPoints.INIT_SESSION}`,
        params,
      )
    }
  },
  initSessionRolePlay: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${sentencePracticeEndPoints.INIT_SESSION_ROLE_PLAY}`,
        params,
      )
    }
  },
  getRolePlayDetails: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${sentencePracticeEndPoints.GET_ROLE_PLAY_DETAILS}/${params.sentence_practice_history_id}/role-play-configs`,
        {},
      )
    }
  },
  getSentenceSummary: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${sentencePracticeEndPoints.GET_SENTENCES_SUMMARY}/${params.sentencePracticeHistoryId}/summaries`,
        {},
      )
    }
  },
}

export default sentencePracticeRequest
